<script setup>
defineProps({
  title: String,
  subtitle: String,
  imageSrc: String,
  reversed: Boolean,
})
</script>

<template>
  <div class="how-to-container">
    <div class="how-to-card" :class="{'ltr-background': reversed, 'rtl-background': !reversed}">
      <div class="how-to-card-content" :class="{'order-1': !reversed, 'order-2': reversed}">
        <div class="how-to-title">{{ title }}</div>
        <div class="how-to-subtitle">{{ subtitle }}</div>
        <div class="how-to-bar"></div>
        <slot class="how-to-content"></slot>
      </div>
      <div class="how-to-image" :class="{'order-1 cut-right': reversed, 'order-2 cut-left': !reversed}">
        <img :src="imageSrc" alt=""/>
      </div>
    </div>
  </div>
</template>

<style scoped>
.how-to-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;

  .cut-right {
    clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
  }

  .cut-left {
    clip-path: polygon(10% 0, 100% 0, 100% 100%, 0 100%);
  }

  .ltr-background {
    background-image: linear-gradient(250deg, color-mix(in srgb, var(--accent-color), transparent 95%), transparent 50%);
  }

  .rtl-background {
    background-image: linear-gradient(-250deg, color-mix(in srgb, var(--accent-color), transparent 95%), transparent 50%);
  }

  .how-to-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #eee;

    img {
      max-height: 300px;
      object-fit: cover;
      margin: 5%;
    }

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  .how-to-card {
    display: flex;
    margin-bottom: 40px;
    border: 2px solid #ddd;
    border-radius: 10px;
    min-width: 300px;
    max-width: var(--max-width-main);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    overflow: hidden;

    .how-to-title {
      text-align: left;
      font-size: 1.5rem;
      font-weight: 700;
      margin: 0 10px;
    }

    .how-to-card-content {
      padding: 20px 20px;
    }

    .how-to-subtitle {
      color: #999;
      margin: 0 10px;
    }

    .how-to-bar {
      background-color: var(--accent-color);
      border-radius: 5px;
      width: 50px;
      height: 5px;
      margin: 10px 10px;
    }

    .how-to-content {
      /*font-size: 0.9rem;*/
      margin-left: 20px;
    }
  }
}
</style>